import type { AlaffiaClient } from "@alaffia-technology-solutions/client-sdk";

import { cognitoConfig } from "./cognitoConfig";

export interface LocationActions {
  replace: (url: string) => void;
  readonly origin: string;
}

const defaultLocationActions: LocationActions = {
  replace: (url: string) => window.location.replace(url),
  get origin(): string {
    return window.location.origin;
  },
};

export const performLogout = async (
  alaffiaClient: AlaffiaClient,
  locationActions: LocationActions = defaultLocationActions,
): Promise<void> => {
  await alaffiaClient.auth.logoutWithServerInvalidation({});
  const logoutUri = encodeURIComponent(`${locationActions.origin}/`);
  locationActions.replace(
    `${cognitoConfig.domain}/logout?client_id=${cognitoConfig.clientId}&logout_uri=${logoutUri}`,
  );
};
